function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);




/* drone image hotspot*/
/*
console.log('hello');

var x1_icon = document.getElementById('x1_icon');
x1_icon.style.position = 'absolute';
x1_icon.style.top = '15%';
x1_icon.style.left = '56%';

x1_icon.style.marginLeft = '-20px';
x1_icon.style.width = '30px';
x1_icon.style.height = '30px';
x1_icon.style.borderRadius = '20px';
x1_icon.style.backgroundColor = 'green';
x1_icon.style.opacity = '0.5';
x1_icon.style.opacity = '1.0';
x1_icon.style.zIndex = '1000';
x1_icon.style.cursor = 'pointer';

x1_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x1 icon";
}
x1_icon.onmouseover = function() {
  document.getElementById("x1_tooltip").innerHTML = "10.5 Gallon Spray Tank"; 
  var x1_pos_x = x1_icon.offsetLeft;
    var x1_pos_y = x1_icon.offsetTop;
    var x1_width = x1_icon.offsetWidth;
    var x1_height = x1_icon.offsetHeight;

    var margin_right = -180;
    var margin_top = -7;



    document.getElementById("x1_tooltip").style.left = x1_pos_x + x1_width + margin_right + "px";
    document.getElementById("x1_tooltip").style.top = x1_pos_y + margin_top + "px";




    document.getElementById("x1_tooltip").style.display = "block";




}
x1_icon.onmouseout = function() {
  document.getElementById("x1_tooltip").style.display = "none";
}


var x2_icon = document.getElementById('x2_icon');
x2_icon.style.position = 'absolute';
x2_icon.style.top = '28%';
x2_icon.style.left = '44%';

x2_icon.style.marginLeft = '-20px';
x2_icon.style.width = '30px';
x2_icon.style.height = '30px';
x2_icon.style.borderRadius = '20px';
x2_icon.style.backgroundColor = 'green';
x2_icon.style.opacity = '0.5';
x2_icon.style.opacity = '1.0';
x2_icon.style.zIndex = '1000';
x2_icon.style.cursor = 'pointer';

x2_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x2 icon";
}

x2_icon.onmouseover = function() {
  document.getElementById("x2_tooltip").innerHTML = "Front and rearward facing radar combined with binocular vision"; 
    var x2_pos_x = x2_icon.offsetLeft;
    var x2_pos_y = x2_icon.offsetTop;
    var x2_width = x2_icon.offsetWidth;
    var x2_height = x2_icon.offsetHeight;

    var margin_right = -415;
    var margin_top = -7;


    document.getElementById("x2_tooltip").style.left = x2_pos_x + x2_width + margin_right + "px";
    document.getElementById("x2_tooltip").style.top = x2_pos_y + margin_top + "px";

    document.getElementById("x2_tooltip").style.display = "block";

}

x2_icon.onmouseout = function() {
  document.getElementById("x2_tooltip").style.display = "none";
}



var x3_icon = document.getElementById('x3_icon');
x3_icon.style.position = 'absolute';
x3_icon.style.top = '32%';
x3_icon.style.left = '22%';

x3_icon.style.marginLeft = '-20px';
x3_icon.style.width = '30px';
x3_icon.style.height = '30px';
x3_icon.style.borderRadius = '20px';
x3_icon.style.backgroundColor = 'green';
x3_icon.style.opacity = '0.5';
x3_icon.style.opacity = '1.0';
x3_icon.style.zIndex = '1000';
x3_icon.style.cursor = 'pointer';

x3_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x3 icon";
}

x3_icon.onmouseover = function() {
  document.getElementById("x3_tooltip").innerHTML = "IPX6 water and dust resistant and able to be power washed"; 
    var x3_pos_x = x3_icon.offsetLeft;
    var x3_pos_y = x3_icon.offsetTop;
    var x3_width = x3_icon.offsetWidth;
    var x3_height = x3_icon.offsetHeight;

    var margin_right = -390;
    var margin_top = -7;


    document.getElementById("x3_tooltip").style.left = x3_pos_x + x3_width + margin_right + "px";
    document.getElementById("x3_tooltip").style.top = x3_pos_y + margin_top + "px";


    document.getElementById("x3_tooltip").style.display = "block";
}

x3_icon.onmouseout = function() {
  document.getElementById("x3_tooltip").style.display = "none";
}



var x4_icon = document.getElementById('x4_icon');
x4_icon.style.position = 'absolute';
x4_icon.style.top = '49%';
x4_icon.style.left = '39%';


x4_icon.style.marginLeft = '-20px';
x4_icon.style.width = '30px';
x4_icon.style.height = '30px';
x4_icon.style.borderRadius = '20px';
x4_icon.style.backgroundColor = 'green';
x4_icon.style.opacity = '0.5';
x4_icon.style.opacity = '1.0';
x4_icon.style.zIndex = '1000';
x4_icon.style.cursor = 'pointer';

x4_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x4 icon";
}

x4_icon.onmouseover = function() {
  document.getElementById("x4_tooltip").innerHTML = "12 mega-pixel gimbal camera"; 
    var x4_pos_x = x4_icon.offsetLeft;
    var x4_pos_y = x4_icon.offsetTop;
    var x4_width = x4_icon.offsetWidth;
    var x4_height = x4_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -7;


    document.getElementById("x4_tooltip").style.left = x4_pos_x + x4_width + margin_right + "px";
    document.getElementById("x4_tooltip").style.top = x4_pos_y + margin_top + "px";


    document.getElementById("x4_tooltip").style.display = "block";
}

x4_icon.onmouseout = function() {
  document.getElementById("x4_tooltip").style.display = "none";
}




var x5_icon = document.getElementById('x5_icon');
x5_icon.style.position = 'absolute';
x5_icon.style.top = '69%';
x5_icon.style.left = '85%';


x5_icon.style.marginLeft = '-20px';
x5_icon.style.width = '30px';
x5_icon.style.height = '30px';
x5_icon.style.borderRadius = '20px';
x5_icon.style.backgroundColor = 'green';
x5_icon.style.opacity = '0.5';
x5_icon.style.opacity = '1.0';
x5_icon.style.zIndex = '1000';
x5_icon.style.cursor = 'pointer';

x5_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x5 icon";
}

x5_icon.onmouseover = function() {
  document.getElementById("x5_tooltip").innerHTML = "Two Rotary Style Nozzles"; 
    var x5_pos_x = x5_icon.offsetLeft;
    var x5_pos_y = x5_icon.offsetTop;
    var x5_width = x5_icon.offsetWidth;
    var x5_height = x5_icon.offsetHeight;

    var margin_right = -190;
    var margin_top = -7;

    document.getElementById("x5_tooltip").style.left = x5_pos_x + x5_width + margin_right + "px";
    document.getElementById("x5_tooltip").style.top = x5_pos_y + margin_top + "px";


    document.getElementById("x5_tooltip").style.display = "block";

}

x5_icon.onmouseout = function() {
  document.getElementById("x5_tooltip").style.display = "none";
}



var x6_icon = document.getElementById('x6_icon');
x6_icon.style.position = 'absolute';
x6_icon.style.top = '82%';
x6_icon.style.left = '49%';


x6_icon.style.marginLeft = '-20px';
x6_icon.style.width = '30px';
x6_icon.style.height = '30px';
x6_icon.style.borderRadius = '20px';
x6_icon.style.backgroundColor = 'green';
x6_icon.style.opacity = '0.5';
x6_icon.style.opacity = '1.0';
x6_icon.style.zIndex = '1000';
x6_icon.style.cursor = 'pointer';

x6_icon.onclick = function() {
  document.getElementById("map_msg").innerHTML = "You clicked on the x6 icon";
}

x6_icon.onmouseover = function() {
  document.getElementById("x6_tooltip").innerHTML = "Redesigned spreader cover and frame"; 
    var x6_pos_x = x6_icon.offsetLeft;
    var x6_pos_y = x6_icon.offsetTop;
    var x6_width = x6_icon.offsetWidth;
    var x6_height = x6_icon.offsetHeight;

    var margin_right = -275;
    var margin_top = -7;

    document.getElementById("x6_tooltip").style.left = x6_pos_x + x6_width + margin_right + "px";
    document.getElementById("x6_tooltip").style.top = x6_pos_y + margin_top + "px";


    document.getElementById("x6_tooltip").style.display = "block";

}

x6_icon.onmouseout = function() {
  document.getElementById("x6_tooltip").style.display = "none";
}


function animate_class_x(){
    var x = document.getElementsByClassName("x_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulse 2s infinite";
    }

}

*/



if(document.getElementById('x1_icon') != null){

    var x1_icon = document.getElementById('x1_icon');
x1_icon.style.position = 'absolute';
x1_icon.style.top = '15%';
x1_icon.style.left = '56%';

x1_icon.style.marginLeft = '-20px';
x1_icon.style.width = '30px';
x1_icon.style.height = '30px';
x1_icon.style.borderRadius = '20px';
x1_icon.style.backgroundColor = 'green';
x1_icon.style.opacity = '0.5';
x1_icon.style.opacity = '1.0';
x1_icon.style.zIndex = '1000';
x1_icon.style.cursor = 'pointer';


x1_icon.onmouseover = function() {
  document.getElementById("x1_tooltip").innerHTML = "10.5 Gallon Spray Tank"; 
  var x1_pos_x = x1_icon.offsetLeft;
    var x1_pos_y = x1_icon.offsetTop;
    var x1_width = x1_icon.offsetWidth;
    var x1_height = x1_icon.offsetHeight;

    var margin_right = -180;
    var margin_top = -7;



    document.getElementById("x1_tooltip").style.left = x1_pos_x + x1_width + margin_right + "px";
    document.getElementById("x1_tooltip").style.top = x1_pos_y + margin_top + "px";




    document.getElementById("x1_tooltip").style.display = "block";




}
x1_icon.onmouseout = function() {
  document.getElementById("x1_tooltip").style.display = "none";
}


var x2_icon = document.getElementById('x2_icon');
x2_icon.style.position = 'absolute';
x2_icon.style.top = '28%';
x2_icon.style.left = '44%';

x2_icon.style.marginLeft = '-20px';
x2_icon.style.width = '30px';
x2_icon.style.height = '30px';
x2_icon.style.borderRadius = '20px';
x2_icon.style.backgroundColor = 'green';
x2_icon.style.opacity = '0.5';
x2_icon.style.opacity = '1.0';
x2_icon.style.zIndex = '1000';
x2_icon.style.cursor = 'pointer';



x2_icon.onmouseover = function() {
  document.getElementById("x2_tooltip").innerHTML = "Front and rearward facing radar combined with binocular vision"; 
    var x2_pos_x = x2_icon.offsetLeft;
    var x2_pos_y = x2_icon.offsetTop;
    var x2_width = x2_icon.offsetWidth;
    var x2_height = x2_icon.offsetHeight;

    var margin_right = -415;
    var margin_top = -7;


    document.getElementById("x2_tooltip").style.left = x2_pos_x + x2_width + margin_right + "px";
    document.getElementById("x2_tooltip").style.top = x2_pos_y + margin_top + "px";

    document.getElementById("x2_tooltip").style.display = "block";

}

x2_icon.onmouseout = function() {
  document.getElementById("x2_tooltip").style.display = "none";
}



var x3_icon = document.getElementById('x3_icon');
x3_icon.style.position = 'absolute';
x3_icon.style.top = '32%';
x3_icon.style.left = '22%';

x3_icon.style.marginLeft = '-20px';
x3_icon.style.width = '30px';
x3_icon.style.height = '30px';
x3_icon.style.borderRadius = '20px';
x3_icon.style.backgroundColor = 'green';
x3_icon.style.opacity = '0.5';
x3_icon.style.opacity = '1.0';
x3_icon.style.zIndex = '1000';
x3_icon.style.cursor = 'pointer';



x3_icon.onmouseover = function() {
  document.getElementById("x3_tooltip").innerHTML = "IPX6 water and dust resistant and able to be power washed"; 
    var x3_pos_x = x3_icon.offsetLeft;
    var x3_pos_y = x3_icon.offsetTop;
    var x3_width = x3_icon.offsetWidth;
    var x3_height = x3_icon.offsetHeight;

    var margin_right = -390;
    var margin_top = -7;


    document.getElementById("x3_tooltip").style.left = x3_pos_x + x3_width + margin_right + "px";
    document.getElementById("x3_tooltip").style.top = x3_pos_y + margin_top + "px";


    document.getElementById("x3_tooltip").style.display = "block";
}

x3_icon.onmouseout = function() {
  document.getElementById("x3_tooltip").style.display = "none";
}



var x4_icon = document.getElementById('x4_icon');
x4_icon.style.position = 'absolute';
x4_icon.style.top = '49%';
x4_icon.style.left = '39%';


x4_icon.style.marginLeft = '-20px';
x4_icon.style.width = '30px';
x4_icon.style.height = '30px';
x4_icon.style.borderRadius = '20px';
x4_icon.style.backgroundColor = 'green';
x4_icon.style.opacity = '0.5';
x4_icon.style.opacity = '1.0';
x4_icon.style.zIndex = '1000';
x4_icon.style.cursor = 'pointer';


x4_icon.onmouseover = function() {
  document.getElementById("x4_tooltip").innerHTML = "12 mega-pixel gimbal camera"; 
    var x4_pos_x = x4_icon.offsetLeft;
    var x4_pos_y = x4_icon.offsetTop;
    var x4_width = x4_icon.offsetWidth;
    var x4_height = x4_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -7;


    document.getElementById("x4_tooltip").style.left = x4_pos_x + x4_width + margin_right + "px";
    document.getElementById("x4_tooltip").style.top = x4_pos_y + margin_top + "px";


    document.getElementById("x4_tooltip").style.display = "block";
}

x4_icon.onmouseout = function() {
  document.getElementById("x4_tooltip").style.display = "none";
}




var x5_icon = document.getElementById('x5_icon');
x5_icon.style.position = 'absolute';
x5_icon.style.top = '69%';
x5_icon.style.left = '85%';


x5_icon.style.marginLeft = '-20px';
x5_icon.style.width = '30px';
x5_icon.style.height = '30px';
x5_icon.style.borderRadius = '20px';
x5_icon.style.backgroundColor = 'green';
x5_icon.style.opacity = '0.5';
x5_icon.style.opacity = '1.0';
x5_icon.style.zIndex = '1000';
x5_icon.style.cursor = 'pointer';

x5_icon.onmouseover = function() {
  document.getElementById("x5_tooltip").innerHTML = "Two Rotary Style Nozzles"; 
    var x5_pos_x = x5_icon.offsetLeft;
    var x5_pos_y = x5_icon.offsetTop;
    var x5_width = x5_icon.offsetWidth;
    var x5_height = x5_icon.offsetHeight;

    var margin_right = -190;
    var margin_top = -7;

    document.getElementById("x5_tooltip").style.left = x5_pos_x + x5_width + margin_right + "px";
    document.getElementById("x5_tooltip").style.top = x5_pos_y + margin_top + "px";


    document.getElementById("x5_tooltip").style.display = "block";

}

x5_icon.onmouseout = function() {
  document.getElementById("x5_tooltip").style.display = "none";
}



var x6_icon = document.getElementById('x6_icon');
x6_icon.style.position = 'absolute';
x6_icon.style.top = '82%';
x6_icon.style.left = '49%';


x6_icon.style.marginLeft = '-20px';
x6_icon.style.width = '30px';
x6_icon.style.height = '30px';
x6_icon.style.borderRadius = '20px';
x6_icon.style.backgroundColor = 'green';
x6_icon.style.opacity = '0.5';
x6_icon.style.opacity = '1.0';
x6_icon.style.zIndex = '1000';
x6_icon.style.cursor = 'pointer';



x6_icon.onmouseover = function() {
  document.getElementById("x6_tooltip").innerHTML = "Redesigned spreader cover and frame"; 
    var x6_pos_x = x6_icon.offsetLeft;
    var x6_pos_y = x6_icon.offsetTop;
    var x6_width = x6_icon.offsetWidth;
    var x6_height = x6_icon.offsetHeight;

    var margin_right = -275;
    var margin_top = -7;

    document.getElementById("x6_tooltip").style.left = x6_pos_x + x6_width + margin_right + "px";
    document.getElementById("x6_tooltip").style.top = x6_pos_y + margin_top + "px";


    document.getElementById("x6_tooltip").style.display = "block";

}

x6_icon.onmouseout = function() {
  document.getElementById("x6_tooltip").style.display = "none";
}


function animate_class_x(){
    var x = document.getElementsByClassName("x_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulsex 2s infinite";
    }

}
}










/* product 2*/




if(document.getElementById('y1_icon') != null){

var y1_icon = document.getElementById('y1_icon');

y1_icon.style = 'position: absolute; top: 15%; left: 56%; margin-left: -20px; width: 30px; height: 30px; border-radius: 20px; background-color: green; opacity: 0.5; opacity: 1.0; z-index: 1000; cursor: pointer;'


y1_icon.onmouseover = function() {
  document.getElementById("y1_tooltip").innerHTML = "30L Spray Tank"; 
  var y1_pos_x = y1_icon.offsetLeft;
    var y1_pos_y = y1_icon.offsetTop;
    var y1_width = y1_icon.offsetWidth;
    var y1_height = y1_icon.offsetHeight;

    var margin_right = -155;
    var margin_top = -7;

    document.getElementById("y1_tooltip").style.left = y1_pos_x + y1_width + margin_right + "px";
    document.getElementById("y1_tooltip").style.top = y1_pos_y + margin_top + "px";
    document.getElementById("y1_tooltip").style.display = "block";

}
y1_icon.onmouseout = function() {
  document.getElementById("y1_tooltip").style.display = "none";
}


var y2_icon = document.getElementById('y2_icon');


y2_icon.style = 'position: absolute; top: 19%; left: 48%; margin-left: -20px; width: 30px; height: 30px; border-radius: 20px; background-color: green; opacity: 0.5; opacity: 1.0; z-index: 1000; cursor: pointer;'




y2_icon.onmouseover = function() {
  document.getElementById("y2_tooltip").innerHTML = "IP67 water and dust resistant"; 
    var y2_pos_x = y2_icon.offsetLeft;
    var y2_pos_y = y2_icon.offsetTop;
    var y2_width = y2_icon.offsetWidth;
    var y2_height = y2_icon.offsetHeight;

    var margin_right = -215;
    var margin_top = -7;


    document.getElementById("y2_tooltip").style.left = y2_pos_x + y2_width + margin_right + "px";
    document.getElementById("y2_tooltip").style.top = y2_pos_y + margin_top + "px";

    document.getElementById("y2_tooltip").style.display = "block";

}

y2_icon.onmouseout = function() {
  document.getElementById("y2_tooltip").style.display = "none";
}



var y3_icon = document.getElementById('y3_icon');


y3_icon.style = 'position: absolute; top: 24%; left: 36%; margin-left: -20px; width: 30px; height: 30px; border-radius: 20px; background-color: green; opacity: 0.5; opacity: 1.0; z-index: 1000; cursor: pointer;'



y3_icon.onmouseover = function() {
  document.getElementById("y3_tooltip").innerHTML = "Smart Agriculture Cloud Platform"; 
    var y3_pos_x = y3_icon.offsetLeft;
    var y3_pos_y = y3_icon.offsetTop;
    var y3_width = y3_icon.offsetWidth;
    var y3_height = y3_icon.offsetHeight;

    var margin_right = -245;
    var margin_top = -7;


    document.getElementById("y3_tooltip").style.left = y3_pos_x + y3_width + margin_right + "px";
    document.getElementById("y3_tooltip").style.top = y3_pos_y + margin_top + "px";


    document.getElementById("y3_tooltip").style.display = "block";
}

y3_icon.onmouseout = function() {
  document.getElementById("y3_tooltip").style.display = "none";
}



var y4_icon = document.getElementById('y4_icon');
y4_icon.style.position = 'absolute';
y4_icon.style.top = '49%';
y4_icon.style.left = '39%';



y4_icon.style = 'position: absolute; top: 49%; left: 41%; margin-left: -20px; width: 30px; height: 30px; border-radius: 20px; background-color: green; opacity: 0.5; opacity: 1.0; z-index: 1000; cursor: pointer;'



y4_icon.onmouseover = function() {
  document.getElementById("y4_tooltip").innerHTML = "Dual FPV Cameras for Monitoring"; 
    var y4_pos_x = y4_icon.offsetLeft;
    var y4_pos_y = y4_icon.offsetTop;
    var y4_width = y4_icon.offsetWidth;
    var y4_height = y4_icon.offsetHeight;

    var margin_right = -240;
    var margin_top = -7;


    document.getElementById("y4_tooltip").style.left = y4_pos_x + y4_width + margin_right + "px";
    document.getElementById("y4_tooltip").style.top = y4_pos_y + margin_top + "px";


    document.getElementById("y4_tooltip").style.display = "block";
}

y4_icon.onmouseout = function() {
  document.getElementById("y4_tooltip").style.display = "none";
}




var y5_icon = document.getElementById('y5_icon');



y5_icon.style = 'position: absolute; top: 69%; left: 49%; margin-left: -20px; width: 30px; height: 30px; border-radius: 20px; background-color: green; opacity: 0.5; opacity: 1.0; z-index: 1000; cursor: pointer;'





y5_icon.onmouseover = function() {
  document.getElementById("y5_tooltip").innerHTML = "Spherical Radar System"; 
    var y5_pos_x = y5_icon.offsetLeft;
    var y5_pos_y = y5_icon.offsetTop;
    var y5_width = y5_icon.offsetWidth;
    var y5_height = y5_icon.offsetHeight;

    var margin_right = -190;
    var margin_top = -7;

    document.getElementById("y5_tooltip").style.left = y5_pos_x + y5_width + margin_right + "px";
    document.getElementById("y5_tooltip").style.top = y5_pos_y + margin_top + "px";


    document.getElementById("y5_tooltip").style.display = "block";

}

y5_icon.onmouseout = function() {
  document.getElementById("y5_tooltip").style.display = "none";
}



function animate_class_y(){
    var x = document.getElementsByClassName("y_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulsey 2s infinite";
    }

}

}


/* product 3*/


if(document.getElementById('z1_icon') != null){

    var z1_icon = document.getElementById('z1_icon');
z1_icon.style.position = 'absolute';
z1_icon.style.top = '15%';
z1_icon.style.left = '56%';

z1_icon.style.marginLeft = '-20px';
z1_icon.style.width = '30px';
z1_icon.style.height = '30px';
z1_icon.style.borderRadius = '20px';
z1_icon.style.backgroundColor = 'green';
z1_icon.style.opacity = '0.5';
z1_icon.style.opacity = '1.0';
z1_icon.style.zIndex = '1000';
z1_icon.style.cursor = 'pointer';


z1_icon.onmouseover = function() {
  document.getElementById("z1_tooltip").innerHTML = "5.28 Gallon Spray Tank";
  var z1_pos_x = z1_icon.offsetLeft;
    var z1_pos_y = z1_icon.offsetTop;
    var z1_width = z1_icon.offsetWidth;
    var z1_height = z1_icon.offsetHeight;

    var margin_right = -180;
    var margin_top = -7;



    document.getElementById("z1_tooltip").style.left = z1_pos_x + z1_width + margin_right + "px";
    document.getElementById("z1_tooltip").style.top = z1_pos_y + margin_top + "px";




    document.getElementById("z1_tooltip").style.display = "block";




}
z1_icon.onmouseout = function() {
  document.getElementById("z1_tooltip").style.display = "none";
}


var z2_icon = document.getElementById('z2_icon');
z2_icon.style.position = 'absolute';
z2_icon.style.top = '28%';
z2_icon.style.left = '44%';

z2_icon.style.marginLeft = '-20px';
z2_icon.style.width = '30px';
z2_icon.style.height = '30px';
z2_icon.style.borderRadius = '20px';
z2_icon.style.backgroundColor = 'green';
z2_icon.style.opacity = '0.5';
z2_icon.style.opacity = '1.0';
z2_icon.style.zIndex = '1000';
z2_icon.style.cursor = 'pointer';



z2_icon.onmouseover = function() {
  document.getElementById("z2_tooltip").innerHTML = "Front and rearward facing radar combined with binocular vision"; 
    var z2_pos_x = z2_icon.offsetLeft;
    var z2_pos_y = z2_icon.offsetTop;
    var z2_width = z2_icon.offsetWidth;
    var z2_height = z2_icon.offsetHeight;

    var margin_right = -415;
    var margin_top = -7;


    document.getElementById("z2_tooltip").style.left = z2_pos_x + z2_width + margin_right + "px";
    document.getElementById("z2_tooltip").style.top = z2_pos_y + margin_top + "px";

    document.getElementById("z2_tooltip").style.display = "block";

}

z2_icon.onmouseout = function() {
  document.getElementById("z2_tooltip").style.display = "none";
}



var z3_icon = document.getElementById('z3_icon');
z3_icon.style.position = 'absolute';
z3_icon.style.top = '32%';
z3_icon.style.left = '22%';

z3_icon.style.marginLeft = '-20px';
z3_icon.style.width = '30px';
z3_icon.style.height = '30px';
z3_icon.style.borderRadius = '20px';
z3_icon.style.backgroundColor = 'green';
z3_icon.style.opacity = '0.5';
z3_icon.style.opacity = '1.0';
z3_icon.style.zIndex = '1000';
z3_icon.style.cursor = 'pointer';



z3_icon.onmouseover = function() {
  document.getElementById("z3_tooltip").innerHTML = "IPX6 water and dust resistant and able to be power washed"; 
    var z3_pos_x = z3_icon.offsetLeft;
    var z3_pos_y = z3_icon.offsetTop;
    var z3_width = z3_icon.offsetWidth;
    var z3_height = z3_icon.offsetHeight;

    var margin_right = -390;
    var margin_top = -7;


    document.getElementById("z3_tooltip").style.left = z3_pos_x + z3_width + margin_right + "px";
    document.getElementById("z3_tooltip").style.top = z3_pos_y + margin_top + "px";


    document.getElementById("z3_tooltip").style.display = "block";
}

z3_icon.onmouseout = function() {
  document.getElementById("z3_tooltip").style.display = "none";
}



var z4_icon = document.getElementById('z4_icon');
z4_icon.style.position = 'absolute';
z4_icon.style.top = '49%';
z4_icon.style.left = '39%';


z4_icon.style.marginLeft = '-20px';
z4_icon.style.width = '30px';
z4_icon.style.height = '30px';
z4_icon.style.borderRadius = '20px';
z4_icon.style.backgroundColor = 'green';
z4_icon.style.opacity = '0.5';
z4_icon.style.opacity = '1.0';
z4_icon.style.zIndex = '1000';
z4_icon.style.cursor = 'pointer';


z4_icon.onmouseover = function() {
  document.getElementById("z4_tooltip").innerHTML = "12 mega-pixel gimbal camera"; 
    var z4_pos_x = z4_icon.offsetLeft;
    var z4_pos_y = z4_icon.offsetTop;
    var z4_width = z4_icon.offsetWidth;
    var z4_height = z4_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -7;


    document.getElementById("z4_tooltip").style.left = z4_pos_x + z4_width + margin_right + "px";
    document.getElementById("z4_tooltip").style.top = z4_pos_y + margin_top + "px";


    document.getElementById("z4_tooltip").style.display = "block";
}

z4_icon.onmouseout = function() {
  document.getElementById("z4_tooltip").style.display = "none";
}




var z5_icon = document.getElementById('z5_icon');
z5_icon.style.position = 'absolute';
z5_icon.style.top = '69%';
z5_icon.style.left = '85%';


z5_icon.style.marginLeft = '-20px';
z5_icon.style.width = '30px';
z5_icon.style.height = '30px';
z5_icon.style.borderRadius = '20px';
z5_icon.style.backgroundColor = 'green';
z5_icon.style.opacity = '0.5';
z5_icon.style.opacity = '1.0';
z5_icon.style.zIndex = '1000';
z5_icon.style.cursor = 'pointer';

z5_icon.onmouseover = function() {
  document.getElementById("z5_tooltip").innerHTML = "Two Rotary Style Nozzles"; 
    var z5_pos_x = z5_icon.offsetLeft;
    var z5_pos_y = z5_icon.offsetTop;
    var z5_width = z5_icon.offsetWidth;
    var z5_height = z5_icon.offsetHeight;

    var margin_right = -190;
    var margin_top = -7;

    document.getElementById("z5_tooltip").style.left = z5_pos_x + z5_width + margin_right + "px";
    document.getElementById("z5_tooltip").style.top = z5_pos_y + margin_top + "px";


    document.getElementById("z5_tooltip").style.display = "block";

}

z5_icon.onmouseout = function() {
  document.getElementById("z5_tooltip").style.display = "none";
}



var z6_icon = document.getElementById('z6_icon');
z6_icon.style.position = 'absolute';
z6_icon.style.top = '82%';
z6_icon.style.left = '49%';


z6_icon.style.marginLeft = '-20px';
z6_icon.style.width = '30px';
z6_icon.style.height = '30px';
z6_icon.style.borderRadius = '20px';
z6_icon.style.backgroundColor = 'green';
z6_icon.style.opacity = '0.5';
z6_icon.style.opacity = '1.0';
z6_icon.style.zIndex = '1000';
z6_icon.style.cursor = 'pointer';



z6_icon.onmouseover = function() {
  document.getElementById("z6_tooltip").innerHTML = "Foldable design reduces the aircraft size by 77%"; 
    var z6_pos_x = z6_icon.offsetLeft;
    var z6_pos_y = z6_icon.offsetTop;
    var z6_width = z6_icon.offsetWidth;
    var z6_height = z6_icon.offsetHeight;

    var margin_right = -312;
    var margin_top = -7;

    document.getElementById("z6_tooltip").style.left = z6_pos_x + z6_width + margin_right + "px";
    document.getElementById("z6_tooltip").style.top = z6_pos_y + margin_top + "px";


    document.getElementById("z6_tooltip").style.display = "block";

}

z6_icon.onmouseout = function() {
  document.getElementById("z6_tooltip").style.display = "none";
}


function animate_class_z(){
    var x = document.getElementsByClassName("x_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulsez 2s infinite";
    }

}
}

/*product 4*/


if(document.getElementById('f1_icon') != null){

    var f1_icon = document.getElementById('f1_icon');
f1_icon.style.position = 'absolute';
f1_icon.style.top = '15%';
f1_icon.style.left = '56%';

f1_icon.style.marginLeft = '-20px';
f1_icon.style.width = '30px';
f1_icon.style.height = '30px';
f1_icon.style.borderRadius = '20px';
f1_icon.style.backgroundColor = 'green';
f1_icon.style.opacity = '0.5';
f1_icon.style.opacity = '1.0';
f1_icon.style.zIndex = '1000';
f1_icon.style.cursor = 'pointer';


f1_icon.onmouseover = function() {
  document.getElementById("f1_tooltip").innerHTML = "360-degree omnidirectional obstacle avoidance";
  var f1_pos_x = f1_icon.offsetLeft;
    var f1_pos_y = f1_icon.offsetTop;
    var f1_width = f1_icon.offsetWidth;
    var f1_height = f1_icon.offsetHeight;

    var margin_right = -320;
    var margin_top = -7;



    document.getElementById("f1_tooltip").style.left = f1_pos_x + f1_width + margin_right + "px";
    document.getElementById("f1_tooltip").style.top = f1_pos_y + margin_top + "px";




    document.getElementById("f1_tooltip").style.display = "block";




}
f1_icon.onmouseout = function() {
  document.getElementById("f1_tooltip").style.display = "none";
}


var f2_icon = document.getElementById('f2_icon');
f2_icon.style.position = 'absolute';
f2_icon.style.top = '28%';
f2_icon.style.left = '44%';

f2_icon.style.marginLeft = '-20px';
f2_icon.style.width = '30px';
f2_icon.style.height = '30px';
f2_icon.style.borderRadius = '20px';
f2_icon.style.backgroundColor = 'green';
f2_icon.style.opacity = '0.5';
f2_icon.style.opacity = '1.0';
f2_icon.style.zIndex = '1000';
f2_icon.style.cursor = 'pointer';



f2_icon.onmouseover = function() {
  document.getElementById("f2_tooltip").innerHTML = "RTK module: centimeter-level positioning"; 
    var f2_pos_x = f2_icon.offsetLeft;
    var f2_pos_y = f2_icon.offsetTop;
    var f2_width = f2_icon.offsetWidth;
    var f2_height = f2_icon.offsetHeight;

    var margin_right = -315;
    var margin_top = -7;


    document.getElementById("f2_tooltip").style.left = f2_pos_x + f2_width + margin_right + "px";
    document.getElementById("f2_tooltip").style.top = f2_pos_y + margin_top + "px";

    document.getElementById("f2_tooltip").style.display = "block";

}

f2_icon.onmouseout = function() {
  document.getElementById("f2_tooltip").style.display = "none";
}



var f3_icon = document.getElementById('f3_icon');
f3_icon.style.position = 'absolute';
f3_icon.style.top = '32%';
f3_icon.style.left = '22%';

f3_icon.style.marginLeft = '-20px';
f3_icon.style.width = '30px';
f3_icon.style.height = '30px';
f3_icon.style.borderRadius = '20px';
f3_icon.style.backgroundColor = 'green';
f3_icon.style.opacity = '0.5';
f3_icon.style.opacity = '1.0';
f3_icon.style.zIndex = '1000';
f3_icon.style.cursor = 'pointer';



f3_icon.onmouseover = function() {
  document.getElementById("f3_tooltip").innerHTML = "42 min. maximum flight time"; 
    var f3_pos_x = f3_icon.offsetLeft;
    var f3_pos_y = f3_icon.offsetTop;
    var f3_width = f3_icon.offsetWidth;
    var f3_height = f3_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -7;


    document.getElementById("f3_tooltip").style.left = f3_pos_x + f3_width + margin_right + "px";
    document.getElementById("f3_tooltip").style.top = f3_pos_y + margin_top + "px";


    document.getElementById("f3_tooltip").style.display = "block";
}

f3_icon.onmouseout = function() {
  document.getElementById("f3_tooltip").style.display = "none";
}



var f4_icon = document.getElementById('f4_icon');
f4_icon.style.position = 'absolute';
f4_icon.style.top = '69%';
f4_icon.style.left = '42%';


f4_icon.style.marginLeft = '-20px';
f4_icon.style.width = '30px';
f4_icon.style.height = '30px';
f4_icon.style.borderRadius = '20px';
f4_icon.style.backgroundColor = 'green';
f4_icon.style.opacity = '0.5';
f4_icon.style.opacity = '1.0';
f4_icon.style.zIndex = '1000';
f4_icon.style.cursor = 'pointer';


f4_icon.onmouseover = function() {
  document.getElementById("f4_tooltip").innerHTML = "4 x 5MP multispectral cameras"; 
    var f4_pos_x = f4_icon.offsetLeft;
    var f4_pos_y = f4_icon.offsetTop;
    var f4_width = f4_icon.offsetWidth;
    var f4_height = f4_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -7;


    document.getElementById("f4_tooltip").style.left = f4_pos_x + f4_width + margin_right + "px";
    document.getElementById("f4_tooltip").style.top = f4_pos_y + margin_top + "px";


    document.getElementById("f4_tooltip").style.display = "block";
}

f4_icon.onmouseout = function() {
  document.getElementById("f4_tooltip").style.display = "none";
}




var f5_icon = document.getElementById('f5_icon');
f5_icon.style.position = 'absolute';
f5_icon.style.top = '69%';
f5_icon.style.left = '85%';


f5_icon.style.marginLeft = '-20px';
f5_icon.style.width = '30px';
f5_icon.style.height = '30px';
f5_icon.style.borderRadius = '20px';
f5_icon.style.backgroundColor = 'green';
f5_icon.style.opacity = '0.5';
f5_icon.style.opacity = '1.0';
f5_icon.style.zIndex = '1000';
f5_icon.style.cursor = 'pointer';

f5_icon.onmouseover = function() {
  document.getElementById("f5_tooltip").innerHTML = "Sleek, 2-pound design folds for easy transport"; 
    var f5_pos_x = f5_icon.offsetLeft;
    var f5_pos_y = f5_icon.offsetTop;
    var f5_width = f5_icon.offsetWidth;
    var f5_height = f5_icon.offsetHeight;

    var margin_right = -300;
    var margin_top = -7;

    document.getElementById("f5_tooltip").style.left = f5_pos_x + f5_width + margin_right + "px";
    document.getElementById("f5_tooltip").style.top = f5_pos_y + margin_top + "px";


    document.getElementById("f5_tooltip").style.display = "block";

}

f5_icon.onmouseout = function() {
  document.getElementById("f5_tooltip").style.display = "none";
}



var f6_icon = document.getElementById('f6_icon');
f6_icon.style.position = 'absolute';
f6_icon.style.top = '82%';
f6_icon.style.left = '49%';


f6_icon.style.marginLeft = '-20px';
f6_icon.style.width = '30px';
f6_icon.style.height = '30px';
f6_icon.style.borderRadius = '20px';
f6_icon.style.backgroundColor = 'green';
f6_icon.style.opacity = '0.5';
f6_icon.style.opacity = '1.0';
f6_icon.style.zIndex = '1000';
f6_icon.style.cursor = 'pointer';



f6_icon.onmouseover = function() {
  document.getElementById("f6_tooltip").innerHTML = "20MP RGB camera"; 
    var f6_pos_x = f6_icon.offsetLeft;
    var f6_pos_y = f6_icon.offsetTop;
    var f6_width = f6_icon.offsetWidth;
    var f6_height = f6_icon.offsetHeight;

    var margin_right = -160;
    var margin_top = -7;

    document.getElementById("f6_tooltip").style.left = f6_pos_x + f6_width + margin_right + "px";
    document.getElementById("f6_tooltip").style.top = f6_pos_y + margin_top + "px";


    document.getElementById("f6_tooltip").style.display = "block";

}

f6_icon.onmouseout = function() {
  document.getElementById("f6_tooltip").style.display = "none";
}


function animate_class_f(){
    var x = document.getElementsByClassName("x_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulsef 2s infinite";
    }

}
}

/* product 5*/



if(document.getElementById('s1_icon') != null){

    var s1_icon = document.getElementById('s1_icon');
s1_icon.style.position = 'absolute';
s1_icon.style.top = '15%';
s1_icon.style.left = '56%';

s1_icon.style.marginLeft = '-20px';
s1_icon.style.width = '30px';
s1_icon.style.height = '30px';
s1_icon.style.borderRadius = '20px';
s1_icon.style.backgroundColor = 'green';
s1_icon.style.opacity = '0.5';
s1_icon.style.opacity = '1.0';
s1_icon.style.zIndex = '1000';
s1_icon.style.cursor = 'pointer';


s1_icon.onmouseover = function() {
  document.getElementById("s1_tooltip").innerHTML = "360-degree omnidirectional obstacle avoidance";
  var s1_pos_x = s1_icon.offsetLeft;
    var s1_pos_y = s1_icon.offsetTop;
    var s1_width = s1_icon.offsetWidth;
    var s1_height = s1_icon.offsetHeight;

    var margin_right = -180;
    var margin_top = -70;



    document.getElementById("s1_tooltip").style.left = s1_pos_x + s1_width + margin_right + "px";
    document.getElementById("s1_tooltip").style.top = s1_pos_y + margin_top + "px";




    document.getElementById("s1_tooltip").style.display = "block";




}
s1_icon.onmouseout = function() {
  document.getElementById("s1_tooltip").style.display = "none";
}


var s2_icon = document.getElementById('s2_icon');
s2_icon.style.position = 'absolute';
s2_icon.style.top = '28%';
s2_icon.style.left = '44%';

s2_icon.style.marginLeft = '-20px';
s2_icon.style.width = '30px';
s2_icon.style.height = '30px';
s2_icon.style.borderRadius = '20px';
s2_icon.style.backgroundColor = 'green';
s2_icon.style.opacity = '0.5';
s2_icon.style.opacity = '1.0';
s2_icon.style.zIndex = '1000';
s2_icon.style.cursor = 'pointer';



s2_icon.onmouseover = function() {
  document.getElementById("s2_tooltip").innerHTML = "RTK module: centimeter-level positioning"; 
    var s2_pos_x = s2_icon.offsetLeft;
    var s2_pos_y = s2_icon.offsetTop;
    var s2_width = s2_icon.offsetWidth;
    var s2_height = s2_icon.offsetHeight;

    var margin_right = -360;
    var margin_top = -10;


    document.getElementById("s2_tooltip").style.left = s2_pos_x + s2_width + margin_right + "px";
    document.getElementById("s2_tooltip").style.top = s2_pos_y + margin_top + "px";

    document.getElementById("s2_tooltip").style.display = "block";

}

s2_icon.onmouseout = function() {
  document.getElementById("s2_tooltip").style.display = "none";
}



var s3_icon = document.getElementById('s3_icon');
s3_icon.style.position = 'absolute';
s3_icon.style.top = '32%';
s3_icon.style.left = '22%';

s3_icon.style.marginLeft = '-20px';
s3_icon.style.width = '30px';
s3_icon.style.height = '30px';
s3_icon.style.borderRadius = '20px';
s3_icon.style.backgroundColor = 'green';
s3_icon.style.opacity = '0.5';
s3_icon.style.opacity = '1.0';
s3_icon.style.zIndex = '1000';
s3_icon.style.cursor = 'pointer';



s3_icon.onmouseover = function() {
  document.getElementById("s3_tooltip").innerHTML = "45 min. maximum flight time"; 
    var s3_pos_x = s3_icon.offsetLeft;
    var s3_pos_y = s3_icon.offsetTop;
    var s3_width = s3_icon.offsetWidth;
    var s3_height = s3_icon.offsetHeight;

    var margin_right = -220;
    var margin_top = -7;


    document.getElementById("s3_tooltip").style.left = s3_pos_x + s3_width + margin_right + "px";
    document.getElementById("s3_tooltip").style.top = s3_pos_y + margin_top + "px";


    document.getElementById("s3_tooltip").style.display = "block";
}

s3_icon.onmouseout = function() {
  document.getElementById("s3_tooltip").style.display = "none";
}



var s4_icon = document.getElementById('s4_icon');
s4_icon.style.position = 'absolute';
s4_icon.style.top = '73%';
s4_icon.style.left = '45%';


s4_icon.style.marginLeft = '-20px';
s4_icon.style.width = '30px';
s4_icon.style.height = '30px';
s4_icon.style.borderRadius = '20px';
s4_icon.style.backgroundColor = 'green';
s4_icon.style.opacity = '0.5';
s4_icon.style.opacity = '1.0';
s4_icon.style.zIndex = '1000';
s4_icon.style.cursor = 'pointer';


s4_icon.onmouseover = function() {
  document.getElementById("s4_tooltip").innerHTML = "DFOV: 61°, Equivalent Focal Length: 40mm, Resolution 640 × 512"; 
    var s4_pos_x = s4_icon.offsetLeft;
    var s4_pos_y = s4_icon.offsetTop;
    var s4_width = s4_icon.offsetWidth;
    var s4_height = s4_icon.offsetHeight;

    var margin_right = -210;
    var margin_top = -60;


    document.getElementById("s4_tooltip").style.left = s4_pos_x + s4_width + margin_right + "px";
    document.getElementById("s4_tooltip").style.top = s4_pos_y + margin_top + "px";


    document.getElementById("s4_tooltip").style.display = "block";
}

s4_icon.onmouseout = function() {
  document.getElementById("s4_tooltip").style.display = "none";
}




var s5_icon = document.getElementById('s5_icon');
s5_icon.style.position = 'absolute';
s5_icon.style.top = '69%';
s5_icon.style.left = '85%';


s5_icon.style.marginLeft = '-20px';
s5_icon.style.width = '30px';
s5_icon.style.height = '30px';
s5_icon.style.borderRadius = '20px';
s5_icon.style.backgroundColor = 'green';
s5_icon.style.opacity = '0.5';
s5_icon.style.opacity = '1.0';
s5_icon.style.zIndex = '1000';
s5_icon.style.cursor = 'pointer';

s5_icon.onmouseover = function() {
  document.getElementById("s5_tooltip").innerHTML = "Sleek, 2-pound design folds for easy transport"; 
    var s5_pos_x = s5_icon.offsetLeft;
    var s5_pos_y = s5_icon.offsetTop;
    var s5_width = s5_icon.offsetWidth;
    var s5_height = s5_icon.offsetHeight;

      var margin_right = -200;
    var margin_top = -50;

    document.getElementById("s5_tooltip").style.left = s5_pos_x + s5_width + margin_right + "px";
    document.getElementById("s5_tooltip").style.top = s5_pos_y + margin_top + "px";


    document.getElementById("s5_tooltip").style.display = "block";

}

s5_icon.onmouseout = function() {
  document.getElementById("s5_tooltip").style.display = "none";
}



var s6_icon = document.getElementById('s6_icon');
s6_icon.style.position = 'absolute';
s6_icon.style.top = '82%';
s6_icon.style.left = '54%';


s6_icon.style.marginLeft = '-20px';
s6_icon.style.width = '30px';
s6_icon.style.height = '30px';
s6_icon.style.borderRadius = '20px';
s6_icon.style.backgroundColor = 'green';
s6_icon.style.opacity = '0.5';
s6_icon.style.opacity = '1.0';
s6_icon.style.zIndex = '1000';
s6_icon.style.cursor = 'pointer';



s6_icon.onmouseover = function() {
  document.getElementById("s6_tooltip").innerHTML = "48MP Wide and 12MP 56x Zoom cameras"; 
    var s6_pos_x = s6_icon.offsetLeft;
    var s6_pos_y = s6_icon.offsetTop;
    var s6_width = s6_icon.offsetWidth;
    var s6_height = s6_icon.offsetHeight;

    var margin_right = -275;
    var margin_top = -7;

    document.getElementById("s6_tooltip").style.left = s6_pos_x + s6_width + margin_right + "px";
    document.getElementById("s6_tooltip").style.top = s6_pos_y + margin_top + "px";


    document.getElementById("s6_tooltip").style.display = "block";

}

s6_icon.onmouseout = function() {
  document.getElementById("s6_tooltip").style.display = "none";
}


function animate_class_s(){
    var x = document.getElementsByClassName("x_icon");
    var i;
    for (i = 0; i < x.length; i++) {
        x[i].style.border = "5px solid green";
        x[i].style.borderRadius = "50%";
        x[i].style.animation = "pulses 2s infinite";
    }

}
}

// 2024 Theme Corrections & Additions
var btnModal = document.querySelector('.btn-modal');
var modal = document.querySelector('.modal');
var closeModal = document.querySelector('.close-modal');

btnModal.addEventListener('click', function() {
  modal.classList.add('open');
});
closeModal.addEventListener('click', function() {
  modal.classList.remove('open');
});













